var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { SegmentedControlRadioComponent } from './segmented-control-radio.component';
// import { validateCardNumber } from '@ibe.components/shared/payment/payment-method-card/credit-card-validator';
var RadioOption = /** @class */ (function () {
    function RadioOption(label, value, disableButton, tooltip) {
        this.label = label;
        this.value = value;
        if (disableButton) {
            this.disableButton = disableButton;
        }
        if (tooltip) {
            this.tooltip = tooltip;
        }
    }
    return RadioOption;
}());
export { RadioOption };
var INDRASegmentedControlRadioComponent = /** @class */ (function (_super) {
    __extends(INDRASegmentedControlRadioComponent, _super);
    function INDRASegmentedControlRadioComponent() {
        var _this = _super.call(this) || this;
        _this._disable = [];
        _this.selected = new EventEmitter();
        _this._value = '';
        _this.disableClick = false;
        _this.loading = false;
        _this.propagateChange = function (_) { };
        return _this;
    }
    Object.defineProperty(INDRASegmentedControlRadioComponent.prototype, "disable", {
        get: function () {
            return this._disable;
        },
        set: function (val) {
            this._disable = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRASegmentedControlRadioComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.propagateChange(this._value);
            this.selected.emit(this._value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param option {RadioOption} Option item
     * @returns ngClass Object for @option
     */
    INDRASegmentedControlRadioComponent.prototype.TAP_optionClasses = function (option) {
        var disabled = this._disable ? this._disable.find(function (cur) { return cur.value === option.value; }) : false;
        return {
            'active': option.value === this.value,
            'disable': (disabled && disabled.value != this._value) || this.loading
        };
    };
    INDRASegmentedControlRadioComponent.prototype.TAP_select = function (value) {
        var _this = this;
        if (this.loading) {
            return;
        }
        if (value == this.value && this.disableClick) {
            this.value = '';
            return;
        }
        var disabled = this._disable.find(function (cur) { return cur.value === value && cur.value != _this._value; });
        if (disabled)
            return;
        this.value = value;
    };
    INDRASegmentedControlRadioComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    INDRASegmentedControlRadioComponent.prototype.registerOnTouched = function (fn) { };
    INDRASegmentedControlRadioComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    return INDRASegmentedControlRadioComponent;
}(SegmentedControlRadioComponent));
export { INDRASegmentedControlRadioComponent };
